export const mutations = {
  // ===========================
  // == Global

  SET_API_ERROR: (state, value) => {
    state.apiError = value
  },
  SET_LOADING_REQUEST: (state, value) => {
    state.loadingRequest = value
  },
  SET_NOTIFICATION: (state, value) => {
    state.notification = value
  },
  SET_UPLOAD_PROGRESS: (state, value) => {
    state.uploadProgress = value
  },

  // ===========================
  // == Authentication

  SET_CURRENT_CLIENT: (state, value) => {
    state.currentClient = value
  },
  SET_CLIENT_AUTH: (state, value) => {
    state.clientAuth = value
  },
  SET_CLIENT_LOADED: (state, value) => {
    state.clientLoaded = value
  },
  SET_CURRENT_USER: (state, value) => {
    state.currentUser = value
    state.userLoaded = !_.isEmpty(value)
  },
  SET_USER_AUTH: (state, value) => {
    state.userAuth = value
  },
  SET_USER_LOADED: (state, value) => {
    state.userLoaded = value
  },

  // ===========================
  // == Set data for Client

  SET_COUNTS: (state, value) => {
    state.counts = value
  },
  SET_PRODUCT_REGISTRATIONS: (state, value) => {
    state.productRegistrations = value
  },
  SET_PR_FORM_INFOS: (state, value) => {
    state.prFormInfos = value
  },
  SET_REVIEWS: (state, value) => {
    state.reviews = value
  },

  // ===========================
  // == Set data for User

  SET_DOCUMENTS: (state, value) => {
    state.documents = value
  },
  SET_INTERVENTIONS: (state, value) => {
    state.interventions = value
  },
  SET_TRAININGS: (state, value) => {
    state.trainings = value
  }
}
